// removed by extract-text-webpack-plugin
module.exports = {"btn-red":"btn-red__y92qf","btn-blue":"btn-blue__KPWep","btn-yellow":"btn-yellow__2yOVl"};


//////////////////
// WEBPACK FOOTER
// ./components/nfoPage/nfoStates/nfoStates.scss
// module id = 613
// module chunks = 68